import * as React from 'react'
import { SVGProps } from 'react'
import PropTypes from 'prop-types'
interface SVGRProps {
    title?: string;
    titleId?: string;
}
function SvgAftalearkiv({
    title,
    titleId,
    ...props
}: SVGProps<SVGSVGElement> & SVGRProps) {
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            viewBox="0 0 26 23"
            fill="none"
            aria-labelledby={titleId}
            {...props}
        >
            {title ? <title id={titleId}>{title}</title> : null}
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M20.24 9.508V.698A.69.69 0 0 0 19.558 0H6.62a.69.69 0 0 0-.682.698v8.81H20.24ZM2.422 11.851a2.907 2.907 0 0 1 2.3-2.296V6.132H2.568c-.894 0-1.621.744-1.621 1.659v11.453l1.475-7.393Zm19.663-3.608c.713 0 1.302.555 1.374 1.265h-2.004V8.243h.63Zm.963 13.229.42-2.102 1.526-7.656a.812.812 0 0 0-.218-.733.771.771 0 0 0-.551-.23H5.227c-.045 0-.09.002-.135.006-.03.002-.06.007-.09.01l-.015.003c-.008 0-.015.002-.023.003a1.595 1.595 0 0 0-.115.024l-.006.001a1.673 1.673 0 0 0-1.23 1.302l-1.744 8.733c-.197.99.543 1.917 1.531 1.917h18.117c.743 0 1.382-.534 1.53-1.278ZM18.492 7.224a.614.614 0 0 0-.608-.621H8.293a.614.614 0 0 0-.608.621c0 .343.272.621.608.621h9.591a.614.614 0 0 0 .608-.62Zm-.608-3.829c.336 0 .608.279.608.622a.614.614 0 0 1-.608.62H8.293a.614.614 0 0 1-.608-.62c0-.344.272-.622.608-.622h9.591Z"
                fill="#297A71"
            />
        </svg>
    )
}
SvgAftalearkiv.propTypes = {
    title: PropTypes.string,
    fill: PropTypes.string,
    width: PropTypes.string,
    height: PropTypes.string,
    stroke: PropTypes.string,
    color: PropTypes.string,
}
export default SvgAftalearkiv
